import axios from "axios";
import AlertModal from "components/modals/components/AlertModal.vue";
import Vue from "vue";

/**
 * Выход из аккаунта
 * @param store
 * @param apollo
 * @returns {Promise<void>}
 */
export async function logout({ store, router }) {
  store.state._modals.push({
    component: AlertModal,
    options: {
      title: "Выйти из аккаунта",
      message: "Вы уверены, что хотите выйти из аккаунта?",
      isConfirm: true,
      closeBtnTitle: "Отмена",
      confirmBtnTitle: "Выйти",
      closeBtnClass: "btn--gray",
      confirmBtnClass: "btn--red",
      callback: () => {
        store.state.apollo_token = undefined;
        store.state.auth.user = null;
        Vue.prototype.$cookie.delete("apollo_token");
        axios({
          method: "post",
          url: "/token",
          data: {
            token: null,
          },
          headers: {
            "Content-Type": "application/json",
          },
        }).then(() => {
          if (router.currentRoute.name === "user") {
            router.push({ name: "home" }).then(() => {
              location.reload();
            });
          } else {
            location.reload();
          }
        });
      },
    },
  });
}

export function parseCookies(cookieString) {
  const cookies = {};
  if (!cookieString) return cookies;

  cookieString.split(";").forEach((cookie) => {
    const parts = cookie.trim().split("=");
    if (parts.length === 2) {
      const name = decodeURIComponent(parts[0]);
      const value = decodeURIComponent(parts[1]);
      cookies[name] = value;
    }
  });

  return cookies;
}
